import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import MainHero from '../components/MainHero';
import BusinessSelector from '../components/BusinessSelector';
import OperatingLayer from '../components/OperatingLayer';
import HowJmiWorks from '../components/HowJmiWorks';
import CategorySection from '../components/CategorySection';
import SegmentationSection from '../components/SegmentationSection';
import MetalRatesSection from '../components/MetalRatesSection';
import TrustSection from '../components/TrustSection';
import MobileAppsSection from '../components/MobileAppsSection';
import BusinessOnboarding from '../components/BusinessOnboarding';
import FaqSection from '../components/FaqSection';
import OnboardingModal from '../components/OnboardingModal';
import './LandingPage.css';

function LandingPage() {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  return (
    <div className="app-wrapper landing-experience">
      {/* 1. Live Metal Rate Strip */}
      <MetalRateStrip />

      {/* Modern Sticky Navbar */}
      <Navbar onOpenAuthModal={openAuth} />

      <main>
        {/* 1. Main Hero: "Buy. Sell. Manage. Grow. One B2B platform for the jewellery trade." */}
        <MainHero onOpenAuthModal={openAuth} />

        {/* 2. "Choose your business" major split section immediately after hero */}
        <BusinessSelector />

        {/* 8. The JMI Operating Layer (Differentiator: Buyer <-> Operator <-> Seller) */}
        <OperatingLayer />

        {/* 9. How JMI Works (5 steps: Discover, Order, Verify & Prepare, Fulfil, Complete) */}
        <HowJmiWorks />

        {/* 11. Categories Section (Gold, Silver, Diamond, Platinum, Gemstone, Pearl) */}
        <CategorySection />

        {/* 11.5. Segmentation Section (Product Segments + Tech Solutions) */}
        <SegmentationSection />

        {/* 12. Metal Rates Section (Market-linked pricing) */}
        <MetalRatesSection />

        {/* 10. Trust Section (Built for high-value B2B transactions) */}
        <TrustSection />

        {/* 13. Mobile Apps Section (One network. Three operational apps.) */}
        <MobileAppsSection />

        {/* 14. Business Onboarding (Ready to join the JMI network?) */}
        <BusinessOnboarding onOpenAuthModal={openAuth} />

        {/* 15. FAQ Section */}
        <FaqSection />
      </main>

      {/* 16. Corporate Footer */}
      <Footer onOpenAuthModal={openAuth} />

      {/* Authentication / Lead Onboarding Modal */}
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
}

export default LandingPage;